(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-tab-section"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabStates = new Map();
  
  function initTabState(tabIndex) {
    if (!tabStates.has(tabIndex)) {
      tabStates.set(tabIndex, {
        currentPage: 1,
        currentYear: 'all',
        posts: []
      });
    }
  }

  function scrollToTop() {
    const blogSection = document.querySelector('.blog-tab-section');
    if (blogSection) {
      blogSection.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // 新增：根據 URL hash 顯示對應的 tab
  function showTabByHash() {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      const targetTab = document.querySelector(`.blog-tab[data-tab-id="${hash}"]`);
      if (targetTab) {
        const tabIndex = parseInt(targetTab.dataset.tab);
        activateTab(tabIndex - 1); // 因為 activateTab 使用 0-based index
      }
    }
  }

  // 新增：激活指定的 tab
  function activateTab(tabIndex) {
    const tabs = document.querySelectorAll('.blog-tab');
    const contents = document.querySelectorAll('.blog-content');
    
    // 移除所有 active 狀態
    tabs.forEach(t => t.classList.remove('active'));
    contents.forEach(content => content.style.display = 'none');
    
    // 激活指定的 tab
    if (tabs[tabIndex] && contents[tabIndex]) {
      tabs[tabIndex].classList.add('active');
      contents[tabIndex].style.display = 'flex';
      
      const postContainer = contents[tabIndex].querySelector('.blog-posts');
      setupPagination(postContainer, tabIndex + 1);
      
      // 滾動到區塊頂部
      setTimeout(() => {
        scrollToTop();
      }, 100);
    }
  }

  // 新增：更新 URL hash（不觸發頁面重載）
  function updateUrlHash(tabId) {
    if (history.pushState) {
      const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '#' + tabId;
      window.history.pushState({path: newUrl}, '', newUrl);
    } else {
      window.location.hash = tabId;
    }
  }

  function setupPagination(postContainer, tabIndex) {
    initTabState(tabIndex);
    const state = tabStates.get(tabIndex);
    
    const allPosts = Array.from(postContainer.querySelectorAll('.blog-post'));
    const paginationContainer = postContainer.querySelector('.blog-pagination');
    const prevButton = paginationContainer.querySelector('.prev');
    const nextButton = paginationContainer.querySelector('.next');
    const pageNumbers = paginationContainer.querySelector('.page-numbers');
    
    function updatePageNumbers(totalPages, currentPage) {
      pageNumbers.innerHTML = '';
      for (let i = 1; i <= totalPages; i++) {
        const pageButton = document.createElement('button');
        pageButton.classList.add('page-number');
        if (i === currentPage) {
          pageButton.classList.add('active');
        }
        pageButton.textContent = i;
        pageButton.addEventListener('click', () => {
          showPage(i);
          scrollToTop();
        });
        pageNumbers.appendChild(pageButton);
      }
    }

    function showPage(pageNum) {
      const state = tabStates.get(tabIndex);
      state.currentPage = pageNum;
      
      const filteredPosts = allPosts.filter(post => {
        const postYears = post.dataset.year.split(',');
        return state.currentYear === 'all' || postYears.includes(state.currentYear);
      });

      const startIndex = (pageNum - 1) * 10;
      const endIndex = startIndex + 10;
      
      allPosts.forEach(post => post.style.display = 'none');
      filteredPosts.slice(startIndex, endIndex).forEach(post => {
        post.style.display = 'flex';
      });

      const totalPages = Math.ceil(filteredPosts.length / 10);
      updatePageNumbers(totalPages, pageNum);

      prevButton.style.display = pageNum > 1 ? 'block' : 'none';
      nextButton.style.display = pageNum < totalPages ? 'block' : 'none';
    }

    prevButton.addEventListener('click', () => {
      const state = tabStates.get(tabIndex);
      if (state.currentPage > 1) {
        showPage(state.currentPage - 1);
        scrollToTop();
      }
    });

    nextButton.addEventListener('click', () => {
      const state = tabStates.get(tabIndex);
      const filteredPosts = allPosts.filter(post => {
        const postYears = post.dataset.year.split(',');
        return state.currentYear === 'all' || postYears.includes(state.currentYear);
      });
      const totalPages = Math.ceil(filteredPosts.length / 10);
      if (state.currentPage < totalPages) {
        showPage(state.currentPage + 1);
        scrollToTop();
      }
    });

    const content = postContainer.closest('.blog-content');
    const yearList = content.querySelector('.blog-years-list');
    const yearSelect = content.querySelector('.blog-years-select');
    
    if (yearList) {
      yearList.querySelectorAll('li').forEach(yearItem => {
        yearItem.addEventListener('click', function() {
          const year = this.dataset.year;
          state.currentYear = year;
          
          yearList.querySelectorAll('li').forEach(li => li.classList.remove('active'));
          this.classList.add('active');
          
          if (yearSelect) {
            yearSelect.value = year;
          }
          
          showPage(1);
          scrollToTop();
        });
      });
    }
    
    if (yearSelect) {
      yearSelect.addEventListener('change', function() {
        const year = this.value;
        state.currentYear = year;
        
        if (yearList) {
          yearList.querySelectorAll('li').forEach(li => li.classList.remove('active'));
          const activeLi = yearList.querySelector(`li[data-year="${year}"]`);
          if (activeLi) {
            activeLi.classList.add('active');
          }
        }
        
        showPage(1);
        scrollToTop();
      });
    }

    showPage(1);
  }

  const tabs = document.querySelectorAll('.blog-tab');
  const contents = document.querySelectorAll('.blog-content');
  
  tabs.forEach((tab, tabIndex) => {
    tab.addEventListener('click', function() {
      const tabId = this.dataset.tabId;
      
      activateTab(tabIndex);
      
      // 更新 URL hash
      if (tabId) {
        updateUrlHash(tabId);
      }
    });
  });

  // 初始化所有 tab 的分頁功能
  contents.forEach((content, index) => {
    const postContainer = content.querySelector('.blog-posts');
    setupPagination(postContainer, index + 1);
  });

  // 監聽 hash 變化（瀏覽器前進/後退按鈕）
  window.addEventListener('hashchange', showTabByHash);
  
  // 頁面載入時檢查 hash
  showTabByHash();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
window.handleBack = function(event) {
  event.preventDefault();
  event.stopPropagation();
  
  const currentUrl = window.location.pathname;
  const blogUrl = '{{ blog.url }}';
  // 移除任何可能的 beforeunload 事件監聽器
  window.onbeforeunload = null;
  
  // 檢查當前網址並決定導向
  if (currentUrl.includes('/blogs/success-stories/')) {
    window.location.href = '/pages/success-stories';
  } 
  else if (currentUrl.includes('/blogs/news/') || 
           currentUrl.includes('/blogs/event/') || 
           currentUrl.includes('/blogs/awards/')) {
    window.location.href = '/pages/newsroom';
  } 
  else {
    window.location.href = blogUrl;
  }
}

  } catch(e) { console.error(e); }
})();
})();
